const normalizeText = (value = '') => String(value || '').trim();

export const getImportHistoryMedicationName = (candidate = {}) => {
  const suggestedRecord = candidate.suggestedRecord || {};
  const record = suggestedRecord.record || {};
  const embeddedSuggestion = record.medicationReview?.suggestions?.[0]
    || suggestedRecord.medicationReview?.suggestions?.[0]
    || {};
  return normalizeText(record.medicationName || suggestedRecord.medicationName || embeddedSuggestion.name);
};

export const buildImportHistoryMedicationReviewSource = ({
  source = {},
  candidate = {},
  draft = {},
} = {}) => {
  const suggestedRecord = candidate.suggestedRecord || {};
  const record = suggestedRecord.record || {};
  const category = normalizeText(draft.category || record.category || suggestedRecord.category).toLowerCase();
  if (category !== 'medication_change') return null;

  const embeddedSuggestion = record.medicationReview?.suggestions?.[0]
    || suggestedRecord.medicationReview?.suggestions?.[0]
    || {};
  const name = getImportHistoryMedicationName(candidate);
  if (!name) return null;

  const changeType = normalizeText(
    record.medicationChangeType
    || record.changeType
    || suggestedRecord.changeType
    || embeddedSuggestion.changeType
  );
  const sourceText = normalizeText(draft.sourceText || suggestedRecord.sourceText || record.sourceText || draft.text);
  const localDate = normalizeText(draft.localDate || record.localDate || embeddedSuggestion.effectiveDate);
  const suggestionId = `${source.id || draft.sourceNoteId || 'source'}-import-med-${candidate.key || name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;

  return {
    ...source,
    suggestedMedicationUpdates: [{
      id: suggestionId,
      name,
      dose: normalizeText(record.newDose || record.dose || embeddedSuggestion.dose),
      unit: normalizeText(record.newUnit || record.unit || embeddedSuggestion.unit),
      schedule: normalizeText(record.newSchedule || record.schedule || embeddedSuggestion.schedule),
      changeType,
      startDateText: changeType === 'started' || changeType === 'new_medication' ? localDate : '',
      changeDateText: localDate,
      sourceText,
      needsReview: true,
    }],
  };
};
